import {
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  VStack
} from '@chakra-ui/react';
import React from 'react';
import { MessageTrainsDataType } from '../../../pages/NoticeMessageList';

interface props {
  MessageDataList: MessageTrainsDataType[] | null | undefined;
  DivisionText: string;
  DivisionColor: string;
  isComplete: boolean;
}
export const ObcMessageTable: React.FC<props> = (props) => {
  const { MessageDataList, DivisionText, DivisionColor, isComplete } = props;
  return (
    <VStack h='100%' w='100%'>
      <Flex
        zIndex={3}
        mb={-2.5}
        justifyContent={'center'}
        alignItems={'center'}
        h='9%'
        w='100%'
        bgColor={DivisionColor}
      >
        {DivisionText}
      </Flex>
      <TableContainer h='91%' w='100%' overflowY='auto' overflowX='unset'>
        <Table variant='simple'>
          <Thead borderWidth='1px' top={0} position='sticky' zIndex='docked'>
            <Tr bg='gray.800'>
              <Th w='10%' textAlign='center' borderWidth='1px' color='white'>
                ステータス
              </Th>
              <Th w='10%' textAlign='center' borderWidth='1px' color='white'>
                系統
              </Th>
              <Th w='10%' textAlign='center' borderWidth='1px' color='white'>
                車号
              </Th>
              <Th w='5%' textAlign='center' borderWidth='1px' color='white'>
                乗務員
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {MessageDataList?.map((data, i) => {
              if (data.delivered === isComplete) {
                return (
                  <Tr key={'ObcMessageRow_' + i}>
                    <Td textAlign='center'>
                      {data.work_status === 1 ? '運行中' : '降車中'}
                    </Td>
                    <Td textAlign='center'>{data.line_name}</Td>
                    <Td textAlign='center'>{data.train_no}</Td>
                    <Td textAlign='center'>{data.staff_name}</Td>
                  </Tr>
                );
              }
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </VStack>
  );
};
